<style lang="less" type="text/less" scoped>
    .toast-container{
        position:fixed;
        top:0;
        left:0;
        z-index:999;
        height:100%;
        pointer-events: none;
        width:100%;
        .toast-inner{
            position:absolute;
            top:50%;
            left:0;
            transform:translateY(-50%);
            text-align:center;
            width:100%;
        }
        .toast{
            display:inline-block;
            line-height:25px;
            padding:5px 20px;
            font-size:14px;
            background:rgba(0,0,0,0.7);
            color:#fff;
            border-radius:5px;
        }
    }

    .toast-enter-active, .toast-leave-active{
        transition: opacity .5s ease;
        opacity:1;
    }
    .toast-enter, .toast-leave-active {
        opacity: 0;
    }
</style>
<template>
    <transition name="toast">
        <div class="toast-container" v-if="show" @click="show=false;">
            <div class="toast-inner">
                <div class="toast" v-html="text" @click="show=false;">
                </div>
            </div>
        </div>
    </transition>
</template>
<script>
    var event = require('../lib/event');

    module.exports = {
        data: function () {
            return {
                show:false,
                text:""
            }
        },
        methods: {},
        components: {},
        mounted: function () {
            var vm = this;
            var timeout = null;
            event.on('toast',function (data) {
                vm.show = true;
                vm.text = data;
                if(timeout){
                    clearTimeout(timeout);
                }
                timeout = setTimeout(function () {
                    vm.show = false;
                },2500);
            })
        }
    }
</script>


// WEBPACK FOOTER //
// Toast.vue?4013d625